import React from 'react';
import Image from '~/components/Image';
import A from '~/components/Links/A';
import ValueGuideLink from '~/components/Links/ValueGuideLink';
import FREE_SHIPPING from '~/public/static/how-it-works/free-shipping.png';
import GETTING_PAID from '~/public/static/how-it-works/getting-paid.png';
import LIST_ITEM from '~/public/static/how-it-works/list-item.png';

const shippingData = [
  {
    title: 'List in Seconds',
    image: LIST_ITEM,
    description: (
      <div>
        Take a few pics, add some details, and list for free in seconds. Need
        help with pricing?{' '}
        <ValueGuideLink className="text-primary-500">
          Check out our value guide
        </ValueGuideLink>
        .
      </div>
    ),
  },
  {
    title: 'Hassle-free Shipping',
    image: FREE_SHIPPING,
    description: (
      <div>
        Buyers pay for shipping. Simply print your label, pack your item and
        ship it!{' '}
        <A
          className="text-primary-500"
          href="https://sidelineswap.com/nav/how-to-ship/l163448"
          title="Learn more about shipping"
        >
          Learn more
        </A>
        .
      </div>
    ),
  },
  {
    title: 'Get Paid',
    image: GETTING_PAID,
    description: (
      <div>
        Buyers can purchase at your list price, or make you an offer. Deliver
        your item as advertised, and get paid.
      </div>
    ),
  },
];

const HowItWorksShippingRow: React.FC = () => (
  <div className="flex flex-col md:flex-row md:justify-around">
    {shippingData.map(data => (
      <div
        key={data.title}
        className="mb-6 flex flex-row md:mb-0 md:mr-4 md:max-w-xs md:flex-col md:items-center"
      >
        <Image
          alt={data.title}
          className="mr-4 h-20 w-20 max-w-none flex-shrink-0 md:mb-4 md:mr-0 md:h-32 md:w-32"
          src={data.image}
          height={80}
          width={80}
        />

        <div className="text-left md:text-center">
          <div className="mb-2 text-base font-semibold md:mb-4">
            {data.title}
          </div>

          <div>{data.description}</div>
        </div>
      </div>
    ))}
  </div>
);

export default HowItWorksShippingRow;
